<template>
  <div id="AlertMessage" :style="`color: ${color}`">
    <span class="material-symbols-outlined"> {{ icon }} </span>
    <div> {{ message }} </div>
  </div>
</template>
  
<script>
  import AlertMessage from "@/components/Util/AlertMessage/AlertMessage";
  export default AlertMessage;
</script>
  
<style lang="scss">
  @import "AlertMessage.scss";
</style>
  